import { useId } from "react";
import { Link } from "react-router-dom";
import { useAppTranslation } from "@/i18n/useAppTranslation";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  suffix?: string;
};

export function PrivacyCheckbox({ checked, onChange, disabled, suffix }: Props) {
  const id = useId();
  const { t } = useAppTranslation("legalPage");

  return (
    <div className="flex items-start gap-3">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        required
        className="mt-0.5 size-5 shrink-0 rounded border-brand-primary/30 accent-[#2f6b67]"
      />
      <label htmlFor={id} className="text-sm leading-relaxed text-ink-soft">
        {t("privacyAccept")}{" "}
        <Link to="/privacidad" target="_blank" className="font-medium text-teal-strong underline underline-offset-2">
          {t("privacyPolicy")}
        </Link>
        {suffix ? ` ${suffix}` : "."}
      </label>
    </div>
  );
}
